import { Grid } from "@material-ui/core";
import React from "react";
import { Attachment } from "../../domain/Attachment";
import { DownloadChip } from "../common/DownloadChip";

export type AttachmentListProps = {
  canEdit?: boolean;
  attachments: Attachment[];
  deleteAttachment?: (attachment: Attachment) => void;
  getBlob: (blobId: string) => Promise<Blob>;
};

export const AttachmentList: React.FC<AttachmentListProps> = ({
  canEdit,
  attachments,
  deleteAttachment,
  getBlob,
}) => {
  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          {attachments
            ? attachments.map((attachment) => (
                <React.Fragment key={attachment.id}>
                  <DownloadChip
                    fileName={attachment.fileName}
                    onDelete={() =>
                      deleteAttachment && deleteAttachment(attachment)
                    }
                    getBlob={() => getBlob(attachment.blobId)}
                    disabled={!canEdit}
                  />
                  &nbsp;
                </React.Fragment>
              ))
            : null}
        </Grid>
      </Grid>
    </>
  );
};
